module.exports = __webpack_public_path__ + "img/u4378.f7f7ba51.svg";